import styled from '@emotion/styled';
import theme from '../../../shared/theme';

export const Container = styled.div({
  position: 'relative',
  height: '100%',
  width: '100%',
  '& .recharts-tooltip-wrapper': {
    zIndex: 16,
  },
});

export const InnerLabel = styled.div({
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  fontSize: '0.875rem',
});

export const baseColor = theme.colors.darkBlue;
export const maxOpacity = theme.opacities.pieChartMax;

export const COLORS = [
  theme.colors.darkBlue,
  theme.colors.lightBlue,
  theme.colors.darkGreen,
  theme.colors.darkOrange,
  theme.colors.darkGreen,
  theme.colors.lightBlue,
];
